import {StyleSheet, Text, View} from 'react-native'
import {Feather} from '@expo/vector-icons'

import {SLIDE_ACCENT, SLIDE_FEATHER_ICON} from '#/lib/slideTokens'

export function TypeBadge({type}: {type: string}) {
  const accent = SLIDE_ACCENT[type] ?? '#ffffff'
  const icon = SLIDE_FEATHER_ICON[type] ?? 'help-circle'
  return (
    <View
      style={[
        ss.badge,
        {backgroundColor: accent + '18', borderColor: accent + '44'},
      ]}>
      <Feather name={icon} size={12} color={accent} />
      <Text style={[ss.label, {color: accent}]}>
        {type.replace(/_/g, ' ').toUpperCase()}
      </Text>
    </View>
  )
}

const ss = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 20,
    borderWidth: 1,
    alignSelf: 'flex-start',
  },
  label: {fontSize: 10, fontWeight: '700', letterSpacing: 0.5},
})
